export const setPersistedState = (key, value) => {
  window.localStorage.setItem(key, JSON.stringify(value));
};

export const getPersistedState = (key) => JSON.parse(window.localStorage.getItem(key));

export const removePersistedState = (key) => window.localStorage.removeItem(key);

export const clearPresistedState = () => window.localStorage.clear();
